import React from 'react';
import Grid2 from '@mui/material/Grid2/Grid2';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TipComponent = ({ tip }) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const isMediumScreen = useMediaQuery('(min-width:601px) and (max-width:960px)');
  const isLargeScreen = useMediaQuery('(min-width:961px)');

  let truncatedDescription;
  if (isSmallScreen) {
    truncatedDescription = tip.descripcion.substring(0, 80);
  } else if (isMediumScreen) {
    truncatedDescription = tip.descripcion.substring(0, 200);
  } else if (isLargeScreen) {
    truncatedDescription = tip.descripcion.substring(0, 200);
  }

  return (
    <Grid2 container className="tip-principales">
      <Grid2 size={{ xs: 12, md: 12, lg: 4 }} >
        <img src={tip.imagen} alt="Autor" className="tip-imagen" />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 12, lg: 6 }} className="tips-principales-texto">
        <p className="titulo">{tip.titulo}</p>
        <p className="descripcion">{truncatedDescription}</p>
        <div className="button-container">
          <button onClick={() => navigate(`/tip/${tip.id}`)} className="ver-tip-button">Ver tip</button>
        </div>
      </Grid2>
    </Grid2>
  );
};

export default TipComponent;